import { render } from "./PrenatalInfoAddOrEdit.vue?vue&type=template&id=1d3a765e&scoped=true"
import script from "./PrenatalInfoAddOrEdit.vue?vue&type=script&lang=js"
export * from "./PrenatalInfoAddOrEdit.vue?vue&type=script&lang=js"

import "./PrenatalInfoAddOrEdit.vue?vue&type=style&index=0&id=1d3a765e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3a765e"]])

export default __exports__